import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";
import { Helmet } from "react-helmet-async";

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

export interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  const allItems = [{ label: "Ana Sayfa", url: "/" }, ...items];

  // BreadcrumbList JSON-LD Schema
  const schemaObj = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": allItems.map((item, idx) => ({
      "@type": "ListItem",
      "position": idx + 1,
      "name": item.label,
      "item": item.url ? `https://www.cornergayrimenkul.com.tr${item.url}` : undefined
    }))
  };

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(schemaObj)}
        </script>
      </Helmet>
      <nav aria-label="Breadcrumb" className="py-3 px-4 bg-muted/40 rounded-lg text-sm mb-6 flex items-center flex-wrap gap-2 text-muted-foreground">
        {allItems.map((item, index) => {
          const isLast = index === allItems.length - 1;
          return (
            <div key={index} className="flex items-center gap-2">
              {index === 0 ? (
                <Link to="/" className="flex items-center hover:text-primary transition-colors text-foreground/80">
                  <Home className="h-4 w-4 mr-1" />
                  <span>{item.label}</span>
                </Link>
              ) : isLast || !item.url ? (
                <span className="font-medium text-foreground">{item.label}</span>
              ) : (
                <Link to={item.url} className="hover:text-primary transition-colors">
                  {item.label}
                </Link>
              )}
              {!isLast && <ChevronRight className="h-4 w-4 text-muted-foreground/60 shrink-0" />}
            </div>
          );
        })}
      </nav>
    </>
  );
}
